<template>
    <span>
        <b-badge :variant="variant">{{ status }}</b-badge>
    </span>
</template>

<script>
export default {
    props: {
        status: {
            type: String
        }
    },

    data() {
        return {
            statusPrimary: [
                'ATIVO',
                'ATIVA',
                'SIM',
                'VIGENTE',
                'CADASTRADA',
                'OK',
                'PRONTO PARA MIGRAÇÃO',
                'CONTRATO DISTRIBUÍDO',
                'CONTRATO VIGENTE',
                'ADITIVO DISTRIBUÍDO',
                'ADITIVO VIGENTE',
                'NO PRAZO',
                'NADA CONSTA',
                'REGULAR',
                'SUCESSO',
                'ATUALIZADO',
                'APLICADO',
                'INSTRUTORIA',
                'PROCESSANDO',
                'PESSOA JURÍDICA',
                'PARCELA FIXA',
                'COMPROMETIDO COM SUCESSO',
                'APROVADA',
                'APROVADO',
                'CONCLUÍDO COM SUCESSO',
                'VINCULADO A UM PAGAMENTO',
                'EM ANDAMENTO',
                'EM ANDAMENTO COM ADITIVO',
                'CADASTRADO',
                'INTERMEDIÁRIO',
                'FINALISTA'
            ],
            statusInfo: [
                'PAGA',
                'CONSULTORIA E INSTRUTORIA',
                'EM ABERTO',
                'PESSOA FÍSICA',
                'MOTIVO DE FORÇA MAIOR',
                'ENTREGA MANUAL',
                'ACEITA - AGUARDANDO PAGAMENTO PELO CLIENTE',
                'ENTREGA',
                'ENTREGA MANUAL',
                'SGTEC',
                'ENVIO REGISTRADO',
                'AUTORIZADA',
                'COMPRAS',
                'EM ANÁLISE DE CONFORMIDADE TÉCNICA',
                'ELABORAÇÃO DE ATP E DIREX'
            ],
            statusSuccess: [
                'PROCESSADA',
                'MIGRADO',
                'APROVADA',
                'QUITADO',
                'CONSULTORIA',
                'CONCLUÍDO',
                'COMPROMETIDO',
                'COMPROMETIDA',
                'CONSOLIDADO',
                'CONFERIDO',
                'LIDA',
                'ENVIADA',
                'EM ANDAMENTO',
                'REQUISIÇÃO',
                'APROVADA',
                'CONCLUÍDA COM AVALIAÇÃO',
                'CONCLUÍDA SEM AVALIAÇÃO',
                'CONCLUÍDA COM AVALIAÇÃO COM ADITIVO',
                'CONCLUÍDA SEM AVALIAÇÃO COM ADITIVO',
                'CONVÊNIO VIGENTE',
                'CONCLUÍDA',
                'FINALIZADA',
                'PLEITO APROVADO'
            ],
            statusWarning: [
                'EM APROVAÇÃO',
                'DEVOLVIDA',
                'NÃO CONFERIDO',
                'EM PROCESSAMENTO',
                'FALHA NA MIGRAÇÃO',
                'ERROAPI',
                'ERROINTERNO',
                'SUCESSOCOMRESSALVAS',
                'FALHA NA ATUALIZAÇÃO',
                'ERROSISTEMAREMOTO',
                'DOCUMENTOENTRADAINVALIDA',
                'DOCUMENTOENTIDADENAOENCONTRADA',
                'PARAMETROSINVALIDOS',
                'PARAMETROSNAOSUPORTADOS',
                'SISTEMAREMOTOINDISPONIVEL',
                'TEMPOESGOTADO',
                'TENTATIVASESGOTADAS',
                'LIMITESIMULTANEASATINGIDO',
                'CONSULTAINDISPONIVEL',
                'ACESSONEGADO',
                'FALHAAOREALIZARCONSULTA',
                'PROGRAMADO',
                'MODIFICADO',
                'EM APROVAÇÃO PELO GERENTE',
                'EM APROVAÇÃO PELO ASSESSOR DARF',
                'EM PROCESSAMENTO PELO SETOR FINANCEIRO',
                'AGUARDANDO EMISSÃO DO CONTRATO',
                'NÃO COMPROMETIDO',
                'NÃO COMPROMETIDA',
                'NÃO LIDA',
                'NÃO ENVIADA',
                'CANCELADA COM PAGAMENTO',
                'EM ANÁLISE',
                'EM EXECUÇÃO',
                'AGUARDANDO ACEITAÇÃO PELA CREDENCIADA',
                'AGUARDANDO ACEITE DAS CONDIÇÕES CONTRATUAIS',
                'AGUARDANDO COMPROMETIMENTO DOS RECURSOS',
                'CONCLUÍDA - PENDENTE DE ANÁLISE',
                'CONCLUÍDA - EM ANÁLISE',
                'EM ATUALIZAÇÃO',
                'EM ANÁLISE PELO GERENTE',
                'EM ANÁLISE PELA UABS',
                'ATRASADA',
                'ATRASADO',
                'AGUARDANDO INÍCIO DA CONTRATAÇÃO',
                'AGUARDANDO ACEITE',
                'EM AJUSTE PELA UNIDADE DEMANDANTE',
                'AGUARDANDO ANÁLISE DO RODÍZIO',
                'CONVÊNIO ENCERRADO',
                'ESPECIAL',
                'DEVOLVIDA PARA CORREÇÃO',
                'DEVOLVIDO POR FMO',
                'DEVOLVIDO FORA DO PRAZO',
                'AGUARDANDO APROVAÇÃO DOS SERVIÇOS/ENTREGAS',
                'AGUARDANDO ATUALIZAÇÃO DO COMPROMETIMENTO',
                'AGUARDANDO APROVAÇÃO DO DEMANDANTE',
                'AGUARDANDO APROVAÇÃO DO GERENTE',
                'AGUARDANDO ATUALIZAÇÃO',
                'AGUARDANDO SETOR FINANCEIRO',
                'EM ANÁLISE DE PERTINÊNCIA',
                'EM ANÁLISE DE CONFORMIDADE TÉCNICA'
            ],
            statusSecondary: ['INATIVO', 'INATIVA', 'NÃO ATUALIZADO'],
            statusDanger: [
                'NÃO',
                'VENCIDA',
                'VENCIDO',
                'NOK',
                'FALHA PARA MIGRAÇÃO',
                'CONSTA',
                'IRREGULAR',
                'REPROVADA',
                'REPROVADO',
                'PENDENTE',
                'REPROVADO PELO DEMANDANTE',
                'REPROVADO PELO GERENTE',
                'REPROVADA PELO DEMANDANTE',
                'REPROVADA PELO GERENTE',
                'REPROVADO PELO ASSESSOR DARF',
                'REPROVADO PELO SETOR FINANCEIRO',
                'ERRO',
                'PENDÊNCIA SAS',
                'FALHA',
                'CONCLUÍDO COM FALHA',
                'CONCLUÍDA - PENDENTE CORREÇÃO',
                'REPROVADA PELO GERENTE',
                'REPROVADA PELA UABS',
                'PRIORITÁRIO',
                'GLOSADO',
                'REPROVADO PARA AJUSTE PELO FORNECEDOR',
                'REPROVADO PELA UABS PARA AJUSTE',
                'REPROVADO PELO SETOR FINANCEIRO PARA AJUSTE INTERNO',
                'ERRO AO COMPROMETER',
                'COMPROMETIMENTO EXCLUÍDO',
                'PERTINÊNCIA REPROVADA',
                'CONFORMIDADE TÉCNICA REPROVADA'
            ],
            statusDark: [
                'CANCELADA SEM PAGAMENTO',
                'EXCLUÍDO',
                'CANCELADA',
                'FINALIZADA - NÃO ACEITA PELA CREDENCIADA',
                'FINALIZADA - SEM PAGAMENTO PELO CLIENTE',
                'FINALIZADA - SEM RESPOSTA DA CREDENCIADA'
            ]
        }
    },

    computed: {
        variant() {
            if (
                this.statusPrimary.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'primary'
            } else if (
                this.statusInfo.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'info'
            } else if (
                this.statusSuccess.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'success'
            } else if (
                this.statusWarning.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'warning'
            } else if (
                this.statusSecondary.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'secondary'
            } else if (
                this.statusDanger.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'danger'
            } else if (
                this.statusDark.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'dark'
            }
        }
    }
}
</script>
